module.exports = __webpack_public_path__ + "img/7.25818d01.jpg";